import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoGastoService = {
  getTipoGasto,
  guardarTipoGasto,
  getTipoGastoToExport,
  deleteTipoGasto,
}

async function getTipoGasto(idEmpresa) {
  return await ApiBudgety.get('TipoGasto/FindByIdEmpresa/' + idEmpresa)
}

async function guardarTipoGasto(tipoGasto) {
  return await ApiBudgety.post('TipoGasto/InsertOrUpdate/', tipoGasto, {
    headers: {
      ACCION: MenusSistema.mantenedor_linea_gasto.accesos.crear_linea_gasto,
      MENU: MenusSistema.mantenedor_linea_gasto.id,
    },
  })
}

async function getTipoGastoToExport(idEmpresa) {
  return await ApiBudgety.get('TipoGasto/FindByIdEmpresaToExport/' + idEmpresa)
}

async function deleteTipoGasto(id) {
  return await ApiBudgety.post('TipoGasto/Delete/' + id, null, {
    headers: {
      ACCION: MenusSistema.mantenedor_linea_gasto.accesos.remover_linea_gasto,
      MENU: MenusSistema.mantenedor_linea_gasto.id,
    },
  })
}
